/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { P as n } from "../chunks/constants.CLW3UOOg.js";
const t = (r) => {
  r && console.warn(`[${n}]: ${r}`);
};
export {
  t as default
};
